import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="language-switcher" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button
                onClick={() => changeLanguage('en')}
                className={i18n.language === 'en' ? 'active' : ''}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: i18n.language === 'en' ? 'bold' : 'normal',
                    color: i18n.language === 'en' ? 'var(--gold)' : 'inherit'
                }}
            >
                English
            </button>
            <span>|</span>
            <button
                onClick={() => changeLanguage('ta')}
                className={i18n.language === 'ta' ? 'active' : ''}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: i18n.language === 'ta' ? 'bold' : 'normal',
                    color: i18n.language === 'ta' ? 'var(--gold)' : 'inherit'
                }}
            >
                தமிழ்
            </button>
        </div>
    );
};

export default LanguageSwitcher;
